import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MyProgramConstant } from '@app/common/constant/my-program.constant';
import { MyProgram } from '@app/models/system/my-program.model';
import { getMyPrograms, MyProgramState } from '@app/selectors/system/my-program.selector';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-company',
    templateUrl: './company.component.html',
    styleUrls: ['./company.component.css']
})
export class CompanyComponent implements OnInit {
    myPrograms$ = new Observable<MyProgram[]>();
    footerMenu: MyProgram[] = [];

    activeFooter: MyProgram = {} as MyProgram;

    constructor(private _myProgramStore: Store<MyProgramState>,
                private _router: Router) {
        this.myPrograms$ = this._myProgramStore.select(getMyPrograms);
    }

    ngOnInit(): void {
        this.myPrograms$.subscribe(res => {
            this.footerMenu = res.filter(y => y.prgKind === MyProgramConstant.kindMenuFooter && Number(y.menuLv) === 2 && y.pid === "mf.About-us");
            this.activeFooter = this.footerMenu.filter(v => v.linkInfo === window.location.pathname)[0];
        });
    }

    onChangeLink(item: MyProgram) {
        this.activeFooter = item;
        this._router.navigateByUrl(item.linkInfo);
    }

}
